import { DatePicker } from '@gef-ui/form-material/DatePickers';

const defaultTextFieldProps = {
	fullWidth: true,
	size: 'small',
	required: 'false',
};

export const DatePickerFullWidth = ({ TextFieldProps, required, ...rest }) => (
	<DatePicker TextFieldProps={{ ...defaultTextFieldProps, ...TextFieldProps, required }} {...rest} />
);

DatePickerFullWidth.propTypes = {
	...DatePicker.propTypes,
};

export default DatePickerFullWidth;
